$(document).ready(function() {
    $(document).on('click', '.open-video-popup', function(e) {
        e.preventDefault();
        const videoId = $(this).data('video');
        const videoEl = $('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoId + '?loop=1&autoplay=1&mute=1&playlist=' + videoId + '&iv_load_policy=3&disablekb=1&controls=0&playsinline=1&enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        $('.box-video-popup .popup-video').empty().html(videoEl);
        $('.box-video-popup').addClass('active');
    });
    $(document).on('click', '.box-video-popup .popup-overlay,.box-video-popup .popup-close', function() {
        $('.box-video-popup').removeClass('active');
        $('.box-video-popup .popup-video').empty();
    });
    if($('.pillar-box-columns').length) {
        $('.pillar-box-columns').flickity({
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            imagesLoaded: true,
            prevNextButtons: false,
            watchCSS: true,
        });
    }
});